/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![ReactionIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAABwElEQVR4nMVVzS5DURDuDlGJ3w3iUVg1uUnvmRmS05kWqfIKiJ94FFYs0ddAsMQWW9TPygKZKu1tz3GrbTjJJDc5c7+Z+WbmO4nEfx5r7SCQLAJK0ZBcAvGLWuX7ECBTSKdzA60A9wDxJhA/Asn7T2ZQSgZ5Q/9pChxARgHlOA4Y6gMRn4ehnfgRfHp6dhxIbn8LDt/V8E06bcf8tKCctgoO1UpOpvL57oYABnmrXXD4Nl6rz36wmYZC01RJKTJdBnmpc9nLVz8WqpODUux4AOKDmgrkKnop66nUXK/OdzyQ21eXsRqA5Kn20lqb/NwJ6IsL4PNVTG+AymYmP7c5lmunbzRAHUUdMeSLapNVuDzZBdaOqAw4mngWhtlh7/6g7NfoT6bgcgqRl/W+DESyA8T3BuXOIG8TzQ9VklvxND8fWTRdDkcFryFmyaddhnhGfRzVPSDm++ulwjeSbwZlFyAzqT+phZSdMiR7euemVlYbslGBUqFqe8GQj5xip0elViW3ZXCSa31PfJRWGi6jmsXvwfks9sGppUsl19V4V0OV8yAIupoCj1KWG1BVLO8J8oVBeVYrfxMf6Cg2TMtfnw+vTtu4l7bPywAAAABJRU5ErkJggg==)
 */
export const ReactionIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        fillRule="evenodd"
        d="M12 23a11 11 0 1 0 0-22 11 11 0 0 0 0 22ZM6.5 13a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm11 0a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm-9.8 1.17a1 1 0 0 1 1.39.27 3.5 3.5 0 0 0 5.82 0 1 1 0 0 1 1.66 1.12 5.5 5.5 0 0 1-9.14 0 1 1 0 0 1 .27-1.4Z"
        clipRule="evenodd"
        className={colorClass}
      />
    </svg>
  );
};
